<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  import DesktopColumnSectionsBar from '@app-components/group/DesktopColumnSectionsBar.svelte';
  import ColumnSection from '@app-components/group/ColumnSection.svelte';

  import MobileSections from '@app-components/mobile/MobileSections.svelte';
  import NoRecsFoundText from '@app-components/group/NoRecsFoundText.svelte';
  import DesktopMap from '@app-components/group/DesktopMap.svelte';

  export let sections = [];
  export let group;
  export let currentUser;
  export let recs;
  export let customClickHandler;
  export let setViewportAutomatically = false;
</script>

<style style="text/scss" lang="scss">
  /* global styles applied for "grid-content" in src/pages/group/Desktop.svelte */

  .map-view {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    .map-view__recs-column {
      width: 30%;
      min-width: 370px;
      height: calc(65vh + 42px);
      overflow-y: hidden;
      overflow-x: hidden;
      padding: 0px 25px;
      margin-left: -20px;
      position: relative;

      &:hover {
        overflow-y: overlay;
        padding-right: 10px;
      }

      &.no-sections {
        margin-top: 44px;
      }
    }

    .map-view__recs-column::-webkit-scrollbar {
      background-color: transparent;
    }

    .map-view__recs-column::-webkit-scrollbar-track {
      margin-top: 60px;
    }

    .map-view__recs-column.no-sections::-webkit-scrollbar-track {
      margin-top: 16px;
    }

    .map-view__map-area {
      flex-grow: 1;
      min-width: 500px;
      height: 65vh;
      margin-top: 42px;
      padding-top: 22px;
      padding-left: 70px;
    }
  }
</style>

<div class="grid-content map-view">
  <div class="map-view__recs-column purple-scrollbar-rounded" class:no-sections={!(sections && sections.length)}>
    <DesktopColumnSectionsBar parentSelector=".map-view__recs-column" />

    {#if group && sections && sections.length > 0}
      <MobileSections mobile={false} />
    {/if}

    {#if sections && sections.length > 0}
      {#each sections.sortBy((x) => x.position) as section (section.id)}
        <ColumnSection id={section.id} mobile={false} editable={false} />
      {/each}
    {:else if recs && recs.length == 0}
      <NoRecsFoundText mobile={true} currentUser={currentUser} group={group} />
    {:else}
      <ColumnSection mobile={false} editable={false} />
    {/if}
  </div>
  <div class="map-view__map-area">
    <DesktopMap
      on:init-map={(e) => dispatch('init-map', e.detail)}
      customClickHandler={customClickHandler}
      bind:setViewportAutomatically={setViewportAutomatically} />
  </div>
</div>
